import { useIntl } from 'react-intl';

import { DQL_DOCUMENTATION_URL } from '../../../core/external-links.js';
import { Flex } from '../../../layouts/flex/Flex.js';
import { textStyle } from '../../../styles/textStyle.sty.js';
import { ExternalLink } from '../../../typography/external-link/ExternalLink.js';
import { Text } from '../../../typography/text/Text.js';
import { dqlEditorMessages as messages } from './messages.js';
import * as styles from './SuggestionsInfoSection.sty.js';

/**
 * Footer rendered below the DQL autocomplete dropdown.
 */
export const SuggestionsInfoSection = () => {
  const intl = useIntl();

  return (
    <Flex
      className={styles.container}
      data-dt-name="SuggestionsInfoSection"
      flexWrap="wrap"
      justifyContent="space-between"
    >
      <Flex className={styles.shortcutsGroup}>
        <Flex alignItems="baseline" gap={4}>
          <Text textStyle="small-emphasized">Esc</Text>
          <Text className={styles.shortcutLabel} textStyle="small">
            {intl.formatMessage(messages.closePanel)}
          </Text>
        </Flex>
        <Flex alignItems="baseline" gap={4}>
          <Text textStyle="small-emphasized">Ctrl+Space</Text>
          <Text className={styles.shortcutLabel} textStyle="small">
            {intl.formatMessage(messages.openPanel)}
          </Text>
        </Flex>
      </Flex>

      <ExternalLink
        href={DQL_DOCUMENTATION_URL}
        className={textStyle({ textStyle: 'small' })}
        data-dt-name="DqlSyntax"
      >
        {intl.formatMessage(messages.dqlSyntaxLink)}
      </ExternalLink>
    </Flex>
  );
};
